import React from "react";
import { Button } from "react-bootstrap";

class CustomButton extends React.Component {
  state = { ch: this.props.msg ? this.props.msg.length : 0 };

  render() {
    return (
      <div
        className="custom-button2"
        style={{ position: "relative", display: "flex" }}
      >
        <Button
          bsStyle={this.props.bsStyle}
          className={this.props.className}
          onClick={this.props.onClick}
          disabled={this.props.isDisabled}
        >
          {this.props.value}
        </Button>
        {this.props.msg ? (
          <div
            className={"custom-tooltip2"}
            style={{
              width: this.state.ch + "ch"
            }}
          >
            {this.props.msg}
            <i className="material-icons">arrow_drop_down</i>
          </div>
        ) : null}
      </div>
    );
  }
}
export default CustomButton;
